module.exports = __webpack_public_path__ + "static/media/RenewableEnergyNew.050d60c6.svg";